<template>
  <div class="app-auto-top-up">
    <div class="header">
      <slot name="txtHeaderByLimit"></slot>
    </div>
    <b-col cols="12">
      <b-form-group :class="['byLimit-group', { 'not-active':  topUp.type !== 'byLimit' }]">
        <b-form-radio name="byLimit" :value="{'type':'byLimit'}">
          <b-col class="trigger">
            <slot name="txtHeaderByLimitInside">Aufladung bei Guthabenunterschreitung</slot>
            <div class="txtInside">
              <slot name="lblByLimitInside">
                Bitte immer, wenn mein Konto unter 5 Euro fällt, den gewählten Betrag auf mein Prepaid-Konto aufladen.
              </slot>
            </div>
          </b-col>
        </b-form-radio>
      </b-form-group>
    </b-col>
    <div class="header">
      <slot name="txtHeaderMonthly"></slot>
    </div>
    <b-col cols="12">
      <b-form-group :class="['monthly-group', { 'not-active':  topUp.type !== 'monthly' } ]">
        <b-form-radio :name="'monthly_'+ 2"
                      :value="{type: 'monthly', trigger: 2}"
        >
          <b-col class="monthly">
            <slot name="txtHeaderMonthlyInside">Monatliche Aufladung</slot>
            <div class="txtInside">
                <slot name="lblMonthlyInside">Bitte an jedem 2. eines Monats den unten gewählten Betrag auf mein Konto aufbuchen:
                </slot>
            </div>
          </b-col>
        </b-form-radio>
      </b-form-group>
    </b-col>
    <div class="input-amount">
      <b-form>
        <b-row>
          <b-col class="first-col">
            <label class="lblInput">
              <slot name="lblInput">Folgenden Betrag automatisch aufbuchen:</slot>
            </label>
          </b-col>
          <b-col class="second-col">
            <b-form-input
              name="amount"
              data-amount
              size="2"
              @input="$v.topUp_.amount.$touch"
              v-model=topUp_.amount
              required
              :state="isValid('topUp_.amount')"
            >
            </b-form-input>
            <b-form-invalid-feedback id="amount-live-feedback">
              <slot v-if="!$v.topUp_.amount.isValid" name="amountLiveFeedback">
                Bitte Betrag zwischen {{ amounts.minValue }} und {{ amounts.maxValue }} wählen.
              </slot>
            </b-form-invalid-feedback>
          </b-col>
          <b-col class="third-col">
            <span>
            <slot name="spanInput">Euro</slot>
            </span>
          </b-col>
        </b-row>
      </b-form>
    </div>
  </div>

</template>

<script>
import price from '@/mixins/price'
import {
  minValue,
  maxValue,
  numeric,
  maxLength,
  minLength,
  required
} from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import isValid from '@/mixins/isValid'

export default {
  name: 'AutoTopUp',
  data () {
    return {
      topUp_: {
        amount: null
      }
    }
  },
  watch: {
    selectedAutoTopUp: {
      immediate: true,
      handler: function (value) {
        this.$emit('update:trigger', value.trigger)
        this.$emit('update:amount', value.amount)
      }
    },
    '$v.$invalid': function (newValue) {
      this.$emit('update:invalid', newValue)
    }
  },
  mounted () {
    this.$emit('update:invalid', this.$v.$invalid)
  },
  computed: {
    selectedAutoTopUp () {
      if (this.topUp) {
        if (this.topUp.type === 'monthly') {
          return Object.assign({}, this.topUp, { amount: parseInt(this.topUp_.amount) })
        }
        if (this.topUp.type === 'byLimit') {
          return Object.assign({}, this.topUp, { amount: parseInt(this.topUp_.amount) }, { trigger: 500 })
        }
        return this.topUp
      }
      return {}
    }
  },
  mixins: [validationMixin, price, isValid],
  props:
    {
      topUp: {
        type: Object
      },
      monthlyValue: {
        type: Array
      },
      amounts: {
        type: Object,
        required: true
      }
    },
  apollo: {},
  validations () {
    return {
      topUp_: {
        amount: {
          required,
          numeric,
          minLength: minLength(this.amounts.minLength),
          naxLength: maxLength(this.amounts.maxLength),
          minValue: minValue(this.amounts.minValue),
          maxValue: maxValue(this.amounts.maxValue)
        }
      }
    }
  }
}
</script>
